/*
 * Small PixiJS Graphics primitives shared across renderers.
 */

import type { Graphics } from 'pixi.js';

/**
 * Trace a star polygon onto a Graphics object. Caller is responsible for the
 * subsequent .fill() / .stroke() call.
 *
 * @param g     Target Graphics.
 * @param cx    Center x.
 * @param cy    Center y.
 * @param n     Number of points.
 * @param outer Outer radius.
 * @param inner Inner radius.
 */
export function drawStar(
  g: Graphics,
  cx: number,
  cy: number,
  n: number,
  outer: number,
  inner: number
): void {
  for (let i = 0; i < n * 2; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = (i * Math.PI) / n - Math.PI / 2;
    const px = cx + Math.cos(a) * r;
    const py = cy + Math.sin(a) * r;
    if (i === 0) g.moveTo(px, py);
    else g.lineTo(px, py);
  }
  g.closePath();
}
